/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Left_TitleInputs */

const en_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Top Left`)
};

const fr_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : En Haut a Gauche`)
};

const de_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Oben links`)
};

const it_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: in alto a sinistra`)
};

const ru_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Верхний левый угол`)
};

const es_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Arriba a la izquierda`)
};

const zh_cn2_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：左上`)
};

const ja_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置: 左上`)
};

const hi_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति: ऊपर बाएँ`)
};

const pt_pt2_position_top_left_title = /** @type {(inputs: Position_Top_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Superior Esquerda`)
};

/**
* | output |
* | --- |
* | "Position: Top Left" |
*
* @param {Position_Top_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_left_title = /** @type {((inputs?: Position_Top_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_top_left_title(inputs)
	if (locale === "de") return de_position_top_left_title(inputs)
	if (locale === "it") return it_position_top_left_title(inputs)
	if (locale === "ru") return ru_position_top_left_title(inputs)
	if (locale === "es") return es_position_top_left_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_top_left_title(inputs)
	if (locale === "ja") return ja_position_top_left_title(inputs)
	if (locale === "hi") return hi_position_top_left_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_top_left_title(inputs)
	return en_position_top_left_title(inputs)
});